<template>
    <div v-if="user !== null">
        <div class="form-group">
            <h5 class="userAuthHeader">メールアドレス変更</h5>
            <div class="row">
                <div class="col">
                    <div>
                        <label for="current_email">現在のメールアドレス</label>
                        <input
                            :value="current_email"
                            type="text"
                            id="current_email"
                            class="form-control"
                            readonly>
                    </div>
                    <div
                        v-if="!user.is_email_verified && helper.isDefaultPlan(user.plan)"
                        class="emailConfirmationNotice text-muted mt-1">
                        <span><b-icon-exclamation-triangle-fill/>メールアドレスが認証されていません</span>
                        <span>（<a href="#" @click="onClickEmailConfirmation">認証メールを再送信</a>）</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="mb-3 mt-3">
                        <label for="email">新規メールアドレス</label>
                        <input
                            v-model="email"
                            type="text"
                            id="email"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.email }"
                            placeholder="メールアドレス">
                        <div v-if="errors.email"
                             class="invalid-feedback d-block">
                            {{ errors.email[0] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <button
                    @click="updateEmail"
                    :disabled="inProgress"
                    class="btn btn-yokumiru-orange">
                    メールアドレスを変更
                </button>
            </div>
        </div>

        <div class="form-group mt-5">
            <div
                v-if="!user.has_password"
                class="alert alert-warning mb-4">
                <div>
                    <b-icon-exclamation-triangle-fill></b-icon-exclamation-triangle-fill>
                    <span>パスワードは現在未設定です。<br>LINE・Appleアカウントによるログインをご利用中の{{ $locale.patient }}様はパスワードを設定してください。</span>
                </div>
            </div>
            <h5 class="userAuthHeader">パスワード変更</h5>
            <div
                v-if="user.has_password"
                class="row">
                <div class="col-12">
                    <div class="mb-3 mb-0-sm">
                        <label for="current_password">現在のパスワード</label>
                        <input
                            v-model="current_password"
                            type="password"
                            id="current_password"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.current_password }"
                            placeholder="パスワードを入力">
                        <div
                            v-if="errors.current_password"
                            class="invalid-feedback d-block">
                            {{ errors.current_password[0] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="mb-3 mb-0-sm">
                        <label for="new_password">新規パスワード</label>
                        <input
                            v-model="password"
                            type="password"
                            id="password"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.password }"
                            placeholder="新規パスワードを入力">
                        <div
                            v-if="errors.password"
                            class="invalid-feedback d-block">
                            {{ errors.password[0] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="mb-3 mb-0-sm">
                        <label for="password_confirmation">新規パスワード（確認）</label>
                        <input
                            v-model="password_confirmation"
                            type="password"
                            id="password_confirmation"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.password }"
                            placeholder="新規パスワードを再入力">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <hr>
                    <ul class="mb-0">
                        <li class="mb-2">
                            <span>パスワードはアルファベット（小・大文字を両方含む）と数字の組み合わせ8～32文字で設定してください</span>
                        </li>
                        <li class="mb-2">
                            <span>パスワードとして使用可能な記号は</span>
                            <span>&nbsp;!&nbsp;$&nbsp;%&nbsp;+&nbsp;/&nbsp;=&nbsp;?&nbsp;[&nbsp;]&nbsp;@&nbsp;</span>
                            <span>です</span>
                        </li>
                    </ul>
                    <hr>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <button
                    class="btn btn-yokumiru-orange"
                    :disabled="inProgress"
                    @click="updatePassword">
                    パスワードを更新
                </button>
            </div>
        </div>

        <div
            v-if="$locale.type === 'consul'"
            class="d-flex justify-content-end mt-4">
            <a href="/leave" class="deleteUserAccount">{{ $locale.appNameJa }}アカウントを退会</a>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'
    import YokumiruHelper from '../../YokumiruHelper'

    export default {
        data: function () {
            return {
                helper: YokumiruHelper,
                user: null,
                errors: {},
                inProgress: false,
                current_email: '',
                email: '',
                current_password: '',
                password: '',
                password_confirmation: '',
            };
        },

        created: function () {
            bus.$on('fetched-user-account', this.initUser)
        },

        mounted: function () {
            // メールアドレス認証結果のアラート
            if (this.$route.query.verified === '1') {
                bus.$emit('alert-success', 'メールアドレスを認証しました。')
            } else if (this.$route.query.verified === '0') {
                bus.$emit('alert-danger', '無効なリクエストです。')
            } else if (this.$route.query.expired === '1') {
                bus.$emit('alert-danger', '有効期限が切れています。')
            }
        },

        methods: {
            initUser: function (user) {
                this.user = user
                this.current_email = user.email
            },

            initEmailInputs: function () {
                this.email = ''
            },

            initPasswordInputs: function () {
                this.current_password = ''
                this.password = ''
                this.password_confirmation = ''
            },

            /**
             * メールアドレス認証メールの再送信
             */
            onClickEmailConfirmation: async function (e) {
                e.preventDefault()

                if (this.inProgress) return
                this.inProgress = true

                const endpoint = constants.user.email.endpoint.base

                await axios.post(`${endpoint}/verify/resend`)
                    .then(() => {
                        bus.$emit('alert-success', '認証メールを再送信しました。')
                    })

                this.inProgress = false
            },

            /**
             * メールアドレス更新
             */
            updateEmail: async function() {
                if (this.inProgress) return
                this.inProgress = true

                const data = {
                    email: this.email,
                }

                await axios.put(constants.user.email.endpoint.base, data)
                    .then(() => {
                        bus.$emit('alert-success', 'メールアドレスを変更しました。')
                        bus.$emit('updated-user-account-email')
                        this.initEmailInputs()
                        this.errors = {}
                    } )
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            /**
             * パスワード更新
             */
            updatePassword: async function() {
                if (this.inProgress) return
                this.inProgress = true

                const data = {
                    current_password: this.current_password,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                }

                await axios.put(constants.user.password.endpoint.base, data)
                    .then(() => {
                        this.initPasswordInputs()
                        this.errors = {}
                        this.user.has_password = true
                        bus.$emit('alert-success', 'パスワードを更新しました。')
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },
        },
    }
</script>

<style scoped lang="scss">
.userAuthHeader {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: bold;
    color: #7D868D;
}

.deleteUserAccount {
    font-size: 13px;
    text-decoration: underline;

    &:hover {
        text-decoration: none;
    }
}

.emailConfirmationNotice {
    font-size: .875rem;

    svg {
        margin-right: 4px;
        fill: #f79e08;
    }

    a {
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>
